import {AbstractVisualFeature} from '../../../visual-feature.js';
import {Racing} from '../racing.js';

import {futureRacingFactory} from './future-racing.factory';

import PALETTE_SCHEMA from './future-racing.palette-schema.yaml';

class FutureRacingFeature extends AbstractVisualFeature {
    get name() {
        return 'FutureRacing';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return futureRacingFactory(PALETTE);
    }
}
if (FEATURES.racing) {
    new FutureRacingFeature(Racing);
}
